import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../../cms/objects/column';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import {
    DEFAULT_LOCKABLE_FARE_ACTIVE_BOOKING_COLUMNS,
    LOCKABLE_FARE_ACTIVE_BOOKING_MODULE,
} from '../constant/lockableFareActiveBookingConstant';

export const setLockableFareActiveBookingPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: LOCKABLE_FARE_ACTIVE_BOOKING_MODULE,
    default_columns: DEFAULT_LOCKABLE_FARE_ACTIVE_BOOKING_COLUMNS,
    default_order_by: 'option_expiry_date',
    default_order: 'asc',
});
